import { CheckIcon } from "@aureskonnect/react-ui";
import { t } from "i18next";
import React from "react";

function ButtonsDivers() {
    const buttonsConfig = [
        {
            label: "Carré",
            borderRadius: "0px",
        },
        {
            label: "Arrondi",
            borderRadius: "10px",
        },
        {
            label: "Pilule",
            borderRadius: "30px",
        },
    ];
    const [selectedType, setSelectedType] = React.useState<string | null>(
        "Arrondi"
    );

    const handleSelect = (label: string) => {
        setSelectedType(label);
    };
    return (
        <div
            className="not-allowed-icon__clz mt-3 mx-2"
            style={{
                display: "flex",
                justifyContent: "space-between",
            }}
        >
            <h5 style={{ fontWeight: "bold" }}>{t("Buttons")}</h5>

            <div
                style={{
                    display: "flex",
                    width: "93%",
                    alignItems: "center",
                    justifyContent: "space-evenly",
                    marginTop: "10px",
                    flexWrap: "wrap",
                }}
            >
                {buttonsConfig.map((button, index) => {
                    const isSelected = selectedType === button.label;
                    return (
                        <div
                            key={index}
                            style={{
                                width: "20%",
                                display: "flex",
                                flexDirection: "column",
                                gap: "5px",
                                cursor: "pointer",
                            }}
                            onClick={() => handleSelect(button.label)}
                        >
                            <div
                                style={{
                                    position: "relative",
                                    width: "100%",
                                    height: "100px",
                                    borderRadius: "10px",
                                    borderBottom: isSelected
                                        ? "5px solid #2a2b2c"
                                        : "1px solid #a19e9e",
                                    border: "1px solid #a19e9e",
                                    background: "#f5f5f5",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    color: "#999",
                                    fontSize: "12px",
                                }}
                            >
                                {isSelected && (
                                    <CheckIcon
                                        className="cmn_chk_selectButton"
                                        height={20}
                                        width={20}
                                        style={{
                                            position: "absolute",
                                            top: "10px",
                                            left: "10px",
                                        }}
                                    />
                                )}
                                <button
                                    type="button"
                                    style={{
                                        width: "70%",
                                        height: "40%",
                                        backgroundColor: "#333",
                                        color: "white",
                                        cursor: "pointer",
                                        borderRadius: button.borderRadius,
                                        border: "none",
                                    }}
                                >
                                    Valider
                                </button>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default ButtonsDivers;
